export const Endpoint = () => `/api/v3/admin/uploadCustomersCSV`;
export type Payload = string;
export type Response = void;
